import { Signal, createEffect, createMemo, createSignal } from "solid-js";
import styles from './st-range-slider.module.css';

export class RangeSliderProps<T> {
    type: { [key: string]: string | T } = {};
    value: [() => number, (v: number) => void] = createSignal(0);
    label: string = "";
}

export default function RangeSlider<T>(props: RangeSliderProps<T>) {
    const [getValue, setValue] = props.value;

    const onChange = (event: Event) => {
        const newValue = parseInt((event.target as HTMLInputElement).value, 10);
        setValue(newValue);
    };

    const intValue = createMemo(() => getValue().toString());
    const strValue = createMemo(() => props.type[intValue()] as string);

    return (<>
        <div class="flexbox horizontal">
            <label aria-label="Verbosity" class="auto">
                <input
                    class={styles.range}
                    type="range"
                    step={1}
                    min={0}
                    max={Math.min(Object.keys(props.type).length / 2 - 1)}
                    value={intValue()}
                    onChange={onChange}
                />
            </label>
        </div>

        <div class="flexbox horizontal middle">
            <span class="auto"></span>
            <span>{strValue()}</span>
        </div>
    </>);
}

RangeSlider.defaultProps = new RangeSliderProps<any>();